import Cookie from 'js-cookie'

export function getCookie (key) {
  var result = localStorage.getItem(key) || Cookie.get(key) || ''
  return result
}
export function getUser () {
  const str = localStorage.getItem('user')
  if (!str) return {}
  const user = JSON.parse(str)
  // if (new Date(user.token_expire_at.replace(/-/gi, '/')).getTime() < Date.now()) {
  //   localStorage.removeItem('user')
  //   localStorage.removeItem('token')
  //   return {}
  // }
  return user
}
export function setCookie (key, value, option = {
  time: 2
}) {
  localStorage.getItem.setItem(key, value)
  Cookie.set(key, value, {expires: option.time / 24})
}



// WEBPACK FOOTER //
// ./src/utils/cookie.js